import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { App as AntdApp } from "antd";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import PrivateRoute from "./utils/PrivateRoute";

// Admin pages
import Users from "./pages/Users";
import Teams from "./pages/Teams";
import Matches from "./pages/Matches";
import PlayerStats from "./pages/PlayerStats";
import Payments from "./pages/Payments";
import Notifications from "./pages/Notifications";
import Tournaments from "./pages/Tournaments";
import Contests from "./pages/Contests";
import Wallets from "./pages/Wallets";
import KYC from "./pages/KYC";
import UserSessions from "./pages/UserSessions";
import Home from "./pages/Home";
import Players from "./pages/Player";
import Sliders from "./pages/Sliders";
import MatchDetails from "./pages/MatchDetails";
import TeamDetails from "./pages/TeamDetails";
import MatchLive from "./pages/MatchLive";
import Start from "./pages/Start";
import Ultimate from "./pages/Ultimate";
import TournamentRegistrations from "./pages/tourPlayerReg";

function App() {
  return (
    <AntdApp>
      <Router>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<Login />} />

          {/* Protected */}
          <Route
            path="/dashboard/*"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          >
            <Route index element={<Home />} />
            <Route path="users" element={<Users />} />
            <Route path="teams" element={<Teams />} />
            <Route path="matches" element={<Matches />} />
            <Route path="player-stats" element={<PlayerStats />} />
            <Route path="payments" element={<Payments />} />
            <Route path="notifications" element={<Notifications />} />
            <Route path="tournaments" element={<Tournaments />} />
            <Route path="contests" element={<Contests />} />
            <Route path="wallets" element={<Wallets />} />
            <Route path="kyc" element={<KYC />} />
            <Route path="user-sessions" element={<UserSessions />} />
            <Route path="players" element={<Players />} />
            <Route path="sliders" element={<Sliders />} />
            <Route path="start" element={<Start />} />
            <Route path="ultimate" element={<Ultimate />} />
            <Route path="matches/:id" element={<MatchDetails />} />
            <Route path="teams/:id" element={<TeamDetails />} />
            <Route path="matches/:id/live" element={<MatchLive />} />
            <Route path="tour-player-registrations" element={<TournamentRegistrations />} />
          </Route>

          {/* Fallback */}
          <Route path="*" element={<Login />} />
        </Routes>
      </Router>
    </AntdApp>
  );
}

export default App;
